import request from '@/utils/request'

// 查询海外信息发布管理列表
export function listHwxxfb(query) {
  return request({
    url: '/web/zscq/hwxxfb/list',
    method: 'get',
    params: query
  })
}

// 查询海外信息发布管理详细
export function getHwxxfb(recid) {
  return request({
    url: '/web/zscq/hwxxfb/' + recid,
    method: 'get'
  })
}
